// 接口字段与左侧菜单匹配规则
export const MENU_BADGE_FIELD_MAP = [
	{ field: 'allCustomerCount', paths: ['AllCustomers'], titles: ['全部客户'] },
  { field: 'reassignCount', paths: ['SubdivideCustomers'], titles: ['再分客户'] },
  { field: 'pendingAllocateCount', paths: ['CustomerAssigned'], titles: ['待分客户'] },
  { field: 'myCustomerCount', paths: ['MyClient'], titles: ['我的客户'] },
  { field: 'importantCount', paths: ['KeyClient'], titles: ['重要客户'] },
  { field: 'teamTransferCount', paths: ['TeamTransfer'], titles: ['团队中转'] },
  { field: 'teamReassignCount', paths: ['TeamSubdivision'], titles: ['团队再分'] },
  { field: 'teamCustomerCount', paths: ['TeamCustomer'], titles: ['团队客户'] },
  { field: 'teamImportantCount', paths: ['TeamImportant'], titles: ['团队重要'] }
]

function matchMenuBadgeRule(item, rule) {
  if (!item || !rule) {
    return false
  }
  const path = String(item.path || '').toLowerCase()
  const name = String(item.name || '').toLowerCase()
  const title = String((item.meta && item.meta.title) || '')
  if ((rule.paths || []).some(keyword => {
    const key = String(keyword).toLowerCase()
    return path.includes(key) || name.includes(key)
  })) {
    return true
  }
  return (rule.titles || []).some(label => title === label || title.includes(label))
}

export function getMenuItemBadgeCount(item, badgeCounts) {
  if (!item || !badgeCounts) {
    return 0
  }
  for (let i = 0; i < MENU_BADGE_FIELD_MAP.length; i++) {
    const rule = MENU_BADGE_FIELD_MAP[i]
    if (matchMenuBadgeRule(item, rule)) {
      const count = Number(badgeCounts[rule.field]) || 0
      return count > 0 ? count : 0
    }
  }
  return 0
}

export function getSubtreeBadgeCount(item, badgeCounts) {
  if (!item) {
    return 0
  }
  if (item.children && item.children.length) {
    return item.children.reduce((sum, child) => sum + getSubtreeBadgeCount(child, badgeCounts), 0)
  }
  return getMenuItemBadgeCount(item, badgeCounts)
}
